import React from 'react';
import I18nButton from './I18nButton/I18nButton';
import './MenuButtons.css';

const MenuButtons = () => {
  return (
    <span className='MenuButtons' >
      {/* <I18nButton /> */}
    </span>
  );
};

export default MenuButtons;
